import type * as core from '../../../../../../../core'

export const query: core.mosaic.Action.Query = {
  selection: {
    '{}': {
      payload: {
        '[]': [
          {
            '{}': {
              insertion: {
                '{}': {
                  inputs: {
                    '{}': {
                      records: {
                        '[]': [
                          {
                            '{}': {
                              values: {
                                '{}': {
                                  '!id': {
                                    '@$': 'proposalDomainId',
                                  },
                                  '!code': {
                                    '@$': 'code',
                                  },
                                  '!name': {
                                    '@$': 'name',
                                  },
                                  '!domain': {
                                    '{}': {
                                      entityId: 'ent:!domains:!domain',
                                      recordId: {
                                        '??': [
                                          {
                                            '@>': [
                                              {
                                                '@$': 'domainId',
                                              },
                                              'recordId',
                                            ],
                                          },
                                          {
                                            '@$': 'domainId',
                                          },
                                        ],
                                      },
                                    },
                                  },
                                  '!proposal': {
                                    '{}': {
                                      entityId: 'ent:!proposals:!proposal',
                                      recordId: {
                                        '@$': 'proposalId',
                                      },
                                    },
                                  },
                                },
                              },
                            },
                          },
                        ],
                      },
                    },
                  },
                  modelId: 'ent:!proposal_domain:!entry',
                },
              },
            },
          },
        ],
      },
      operation: 'dms.mutate',
    },
  },
}
